import * as types from 'actions/player/types';

const initialState = {
  playerType: null,
  startFrom: null,
  queryParams: {},
  isStopped: false,
  currentTime: 0,
  error: null,
  isPlayedDataLoaded: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.OPEN: {
      const { playerType, startFrom, queryParams } = action.payload;
      return {
        ...initialState,
        playerType,
        startFrom,
        queryParams,
      };
    }
    case types.CLOSE:
      return { ...initialState };
    case types.ON_START_PLAYING:
      return { ...state, isStopped: false };
    case types.ON_STOP_PLAYING:
      return { ...state, isStopped: true };
    case types.ON_TIME_UPDATE:
      return { ...state, currentTime: action.payload };
    case types.LOAD_DATA_SUCCESS:
      return { ...state, isPlayedDataLoaded: true };
    case types.ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
